import { Card, EmptyState, Page } from "@shopify/polaris";
import { useTranslation } from "react-i18next";

export default function NotFound() {
  const { t } = useTranslation();
  return (
    <Page>
      <Card>
          <EmptyState image="https://cdn.shopify.com/s/files/1/0262/4071/2726/files/emptystate-files.png" heading={t("NotFound.heading")}>
            <p>{t("NotFound.description")}</p>
          </EmptyState>
      </Card>
    </Page>
  );
}
